import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModuloEnum from "@/core/utils/ModuloEnum"

const componentRouterView = {
    render(c) {
        return c("router-view")
    },
}


const AtaRegistroPrecoRoutes = {
    path: "/ata-registro-preco",
    component: componentRouterView,
    meta: {
        moduleName: "Ata",
        icon: "journal-text",
        modulo: ModuloEnum.NAO_NECESSITA_VERIFICACAO,
        sistema: 2, 
    },
    children: [
        {
            path: "consultar-atas",
            name: "ConsultarAta",
            meta: { description: "Atas", menu: { name: "Atas", permissao: PrivilegiosEnum.ATA_ACESSAR } },
            component: () => import("@/modules/ata-registro-preco/ConsultarAtas.vue"),
        }
    ],
}

export default AtaRegistroPrecoRoutes
